import * as React from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import type { DialogProperties } from './Dialog.types'
import DialogClose from './DialogClose'
import DialogContent from './DialogContent'
import DialogDescription from './DialogDescription'
import DialogHeader from './DialogHeader'
import DialogOverlay from './DialogOverlay'
import DialogPortal from './DialogPortal'
import DialogTitle from './DialogTitle'
import DialogTrigger from './DialogTrigger'

const Dialog: React.FC<React.ComponentProps<typeof DialogPrimitive.Root>> &
    DialogProperties = ({ ...props }) => {
    return <DialogPrimitive.Root data-slot="dialog" {...props} />
}

Dialog.Portal = DialogPortal
Dialog.Trigger = DialogTrigger
Dialog.Header = DialogHeader
Dialog.Content = DialogContent
Dialog.Title = DialogTitle
Dialog.Description = DialogDescription
Dialog.Overlay = DialogOverlay
Dialog.Close = DialogClose

Dialog.displayName = 'Dialog'

export default Dialog
